export enum WindowSize {
  Mobile = 1,
  DesktopSmall = 2,
  DesktopMedium = 3,
  DesktopLarge = 4,
  DesktopFull = 5,
}
